import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { CategoryState } from 'store/category/types';

type SetCategoryPayload = {
  categories: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response;
  offset: number;
};
const setCategoriesReducer = (state: CategoryState, action: PayloadAction<SetCategoryPayload>) => {
  const insertBefore = action.payload.offset < state.familiesOffset;
  if (action.payload) {
    if (state.categories) {
      if (insertBefore) {
        state.categories.families = [...action.payload.categories.families, ...state.categories.families];
      } else {
        state.categories.families.push(...action.payload.categories.families);
      }
      state.categories.filters = action.payload.categories.filters;
    } else {
      state.categories = action.payload.categories;
    }
    state.familiesOffset = Math.min(state.familiesOffset, action.payload.offset);
    state.totalFamiliesFetched += action.payload.categories.families.length;
    state.totalFamiliesAvailable = action.payload.categories.totalFamiliesCount;
  } else {
    state.categories = undefined;
    state.familiesOffset = 0;
    state.totalFamiliesFetched = 0;
    state.totalFamiliesAvailable = 0;
  }
};

export default setCategoriesReducer;
